<template>
    <div>
        <transition  :name="['guthaben_auszahlen','konto_detail'].indexOf($route.name)!=-1?'slide_right_to_left':$route.params.back=='true'?'slide_left_to_right':$route.name=='filter_wahlen'?'slide_bottom_to_top':$route.params.backTop=='true'?'slide_top_to_bottom':'slide'" mode="out-in">
            <router-view></router-view>
        </transition>
        <app-footer v-if="['meine_trends','konto','guthaben_auszahlen','profil'].indexOf($route.name)!=-1"> </app-footer>
    </div>
</template>

<script>
    import Footer from './components/Footer_menu';
    export default {
        name: 'app',
        created(){
            this.$store.dispatch('initNeue');
            this.$store.dispatch('init_release');
        },
        components: {
            appFooter: Footer
        }
    }

</script>

<style lang="scss">
    @import 'assets/css/style';

    #app {
        display: table;
        width: 100%;
        height: 100vh;
        background-color: $lila;
        display: table;

        .img {
            display: table-cell;
            text-align: center;
            vertical-align: middle;
            img {
                width: 620px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue